<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How can I get paid for my book?</h1>
			<p>
				You are able to sign up for ACH/Direct deposit. Other options are not currently available, but will be in the future.
			</p>
		</div>
		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "HowCanIGetPaidForBook",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>